module.exports = __webpack_public_path__ + "static/media/General-Rules.574cb23f.pdf";